const path = require('path')

module.exports = function (state, opts) {
    return {
        enforce: "pre",
        test: /\.js$/,
        exclude: /node_modules|dist|vendors/,
        loader: state.FURTHER_REF + "eslint-loader",
        options: {
        configFile: path.resolve(state.PROJECT_PATH, './.further/.eslintrc.json'),
        rules: Object.assign(
            {},
            {
                "no-debugger": state.IS_DEV ? 1 : 2,
                "no-console": 0,
                "no-dynamic-import": 0,
                "no-empty": 1,
                "no-unused-vars": [1, {"args": "all", "argsIgnorePattern": "^_", "args": "after-used"}],
                "no-unused-args": 0,
                "no-unreachable": state.IS_DEV ? 1 : 2
            }, (opts.custom.esLint ? opts.custom.esLint.rules : {})|| {})
        }
    }
}



// WEBPACK FOOTER //
// ./src/technologies/eslint.js